import type { Condition } from '../../../../../../../../../common/types';
import { PAUSE_CONDITIONS_FIELD_NAME } from '../../../../../../../../../common/ui/constants.tsx';

export const validateConditions = (
	conditions?: Condition[],
	// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
	listName: string,
): boolean | undefined => {
	if (!conditions || conditions.length === 0) {
		if (listName !== PAUSE_CONDITIONS_FIELD_NAME) {
			return true;
		}
	}
	return undefined;
};
